/**
 * ehr#712 (Jay 10-30): the SSN is shown masked, last four digits only, everywhere outside the
 * Demographics edit path. The stored value keeps its old format (XXX-XX-XXXX, the drawer's input
 * mask), so duplicate checks that compare SSNs server-side still compare like with like.
 *
 * The Demographics blob holds an `ssn` field in more than one section (identity = the client,
 * guarantor = the responsible party, plus repeated `guarantor#<n>` entries), so the helpers work
 * on any top-level section that carries one.
 */
/** "***-**-1234" for a stored SSN; "" when there is none. Fewer than 4 digits shows no digits. */
export function maskedSsn(v) {
    if (typeof v !== 'string')
        return '';
    const d = v.replace(/\D/g, '');
    if (!d && !v.includes('*'))
        return '';
    return `***-**-${d.length >= 4 ? d.slice(-4) : '****'}`;
}
/** True for a value that came from maskedSsn: it carries the mask, not a real number. */
export function isMaskedSsn(v) {
    return typeof v === 'string' && v.includes('*');
}
const isSection = (v) => !!v && typeof v === 'object' && !Array.isArray(v);
/**
 * A copy of the Demographics blob with every section's `ssn` masked, plus the section keys that
 * have one on file (the "an SSN exists" flag the drawer shows its Edit button for).
 */
export function maskBlobSsn(data) {
    const out = { ...data };
    const onFile = [];
    for (const [key, sec] of Object.entries(data)) {
        if (!isSection(sec) || typeof sec.ssn !== 'string' || !sec.ssn.trim())
            continue;
        out[key] = { ...sec, ssn: maskedSsn(sec.ssn) };
        onFile.push(key);
    }
    return { data: out, onFile };
}
//# sourceMappingURL=ssn.js.map